import { LocalDate } from '@js-joda/core';

import { commonTranslationKeys, FormContextValues } from '@dreryk/react-common';

import { patientTranslationKeys } from '../../../translations';
import { PersonalIdentifierType } from '../../common.types';
import { PatientSelectIdentifierType } from '../PatientIdentifierTypeField/PatientIdentifierTypeField';

import { StyledDatePicker } from './BirthDateField.styled';

type BirthDateFieldProps = {
   readonly register: FormContextValues['register'];
   readonly personalIdentifierType: PatientSelectIdentifierType;
};

const BirthDateField = (props: BirthDateFieldProps): JSX.Element => {
   return (
      <StyledDatePicker
         testId={'birthDate'}
         controller={props.register('birthDate', {
            required: props.personalIdentifierType.id !== PersonalIdentifierType.MEDICAL_RECORD_NUMBER,
            validate: (date: unknown) => {
               if (
                  props.personalIdentifierType.id === PersonalIdentifierType.GUARDIAN_PESEL &&
                  date instanceof LocalDate
               ) {
                  const lastYear = LocalDate.now().minusYears(1);
                  const isUnderYearOld = LocalDate.from(date).isAfter(lastYear);
                  return isUnderYearOld || patientTranslationKeys.patientOverYearOld;
               }

               return undefined;
            },
         })}
         label={commonTranslationKeys.birthDate}
         placeholder={patientTranslationKeys.datePlaceholder}
         dayValidators={'dayAfterToday'}
         withNavigationArrows
      />
   );
};

export { BirthDateField };
